/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';
import type { DiscreteNumericValueDtoEvaluationType } from './DiscreteNumericValueDtoEvaluationType';
import {
    DiscreteNumericValueDtoEvaluationTypeFromJSON,
    DiscreteNumericValueDtoEvaluationTypeFromJSONTyped,
    DiscreteNumericValueDtoEvaluationTypeToJSON,
} from './DiscreteNumericValueDtoEvaluationType';
import type { DiscreteNumericValueDtoGeometry } from './DiscreteNumericValueDtoGeometry';
import {
    DiscreteNumericValueDtoGeometryFromJSON,
    DiscreteNumericValueDtoGeometryFromJSONTyped,
    DiscreteNumericValueDtoGeometryToJSON,
} from './DiscreteNumericValueDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface DiscreteNumericValueDto
 */
export interface DiscreteNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DiscreteNumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof DiscreteNumericValueDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoEvaluationType}
     * @memberof DiscreteNumericValueDto
     */
    evaluationType?: DiscreteNumericValueDtoEvaluationType | null;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoGeometry}
     * @memberof DiscreteNumericValueDto
     */
    geometry?: DiscreteNumericValueDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericValueDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    $type?: DiscreteNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const DiscreteNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DiscreteNumericValueDtoTypeEnum = typeof DiscreteNumericValueDtoTypeEnum[keyof typeof DiscreteNumericValueDtoTypeEnum];


/**
 * Check if a given object implements the DiscreteNumericValueDto interface.
 */
export function instanceOfDiscreteNumericValueDto(value?: unknown): value is DiscreteNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DiscreteNumericValueDtoTypeEnum)[0];
}

export function DiscreteNumericValueDtoFromJSON(json: any): DiscreteNumericValueDto {
    return DiscreteNumericValueDtoFromJSONTyped(json, false);
}

export function DiscreteNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteNumericValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'defaultValue': !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'evaluationType': !exists(json, 'evaluationType') ? undefined : DiscreteNumericValueDtoEvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'geometry': !exists(json, 'geometry') ? undefined : DiscreteNumericValueDtoGeometryFromJSON(json['geometry']),
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        'availableValues': !exists(json, 'availableValues') ? undefined : json['availableValues'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DiscreteNumericValueDtoToJSON(value?: DiscreteNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'value': value.value,
        'numericId': value.numericId,
        'defaultValue': value.defaultValue,
        'unitAbbreviation': value.unitAbbreviation,
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value.valueType),
        'evaluationType': DiscreteNumericValueDtoEvaluationTypeToJSON(value.evaluationType),
        'decimalPlaces': value.decimalPlaces,
        'geometry': DiscreteNumericValueDtoGeometryToJSON(value.geometry),
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        'availableValues': value.availableValues,
        '$type': value.$type,
    });
}

